import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { styled } from '@gogame/components';
import {
  usePercentFormat,
  useCurrencyFormat,
  useNumberFormat,
} from '@gogame/intl-ts';

import { useValidationErrorsByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { BUDGET } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

export const Metric = ({ name, typeField }) => {
  const value = useViewStateByResolveName(name);
  const formatPercent = usePercentFormat();
  const formatNumber = useNumberFormat();

  const formattedValue = React.useMemo(
    () =>
      ({
        percent: formatPercent,
        number: formatNumber,
      })[typeField](Number(value)),
    [value, typeField]
  );

  return formattedValue;
};

const BudgetValue = styled('span')`
  color: ${({ theme, error }) => (error ? theme.palette.error.main : null)};
`;

const CMetricValue = styled('span')`
  color: ${({ theme, less }) =>
    less ? theme.palette.error.main : theme.palette.success.main};
`;

export const CMetric = ({ name, typeField }) => {
  const { value } = useViewStateByResolveName(name);
  const errors = useValidationErrorsByResolveName(name);
  const formatPercent = usePercentFormat();
  const formatNumber = useNumberFormat();

  const formattedValue = React.useMemo(
    () =>
      ({
        percent: formatPercent,
        number: formatNumber,
      })[typeField](Number(value)),
    [value, typeField]
  );

  return <CMetricValue less={!isEmpty(errors)}>{formattedValue}</CMetricValue>;
};

export const BudgetAmount = () => {
  const budget = useViewStateByResolveName(BUDGET);
  const formatCurrency = useCurrencyFormat();
  const formatBudget = formatCurrency(budget);

  return formatBudget;
};

export const BudgetAllocated = () => {
  const { budgetAllocated } = useViewStateByResolveName();
  const { budgetAllocated: budgetAllocatedErrors } =
    useValidationErrorsByResolveName();
  const formatCurrency = useCurrencyFormat();
  const formatBudgetAllocated = formatCurrency(budgetAllocated);

  return (
    <BudgetValue error={!isEmpty(budgetAllocatedErrors)}>
      {formatBudgetAllocated}
    </BudgetValue>
  );
};

export const BudgetPercent = () => {
  const { budgetPercent } = useViewStateByResolveName();
  const formatPercent = usePercentFormat();

  const formatBudgetPercent = React.useMemo(() => {
    return formatPercent(budgetPercent);
  }, [budgetPercent]);

  return formatBudgetPercent;
};

export const BudgetDaily = () => {
  const { budgetDaily } = useViewStateByResolveName();
  const formatCurrency = useCurrencyFormat();

  const formatBudgetDaily = React.useMemo(() => {
    return formatCurrency(budgetDaily);
  }, [budgetDaily]);

  return formatBudgetDaily;
};
